import { useState } from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import moment from 'moment';

import { BUCKETS, BUCKET_LABELS, money } from '../statementFormat';

const ALL = 'all';

// Every transfer Adyen booked to the merchant's account, filterable by movement.
const StatementLines = ({ lines }) => {
  const [bucket, setBucket] = useState(ALL);
  const shown = bucket === ALL ? lines : lines.filter((line) => line.bucket === bucket);
  const filters = [ALL, ...BUCKETS.filter((key) => lines.some((line) => line.bucket === key))];

  return (
    <TableContainer component={Paper} sx={{ mt: 3 }}>
      <Stack direction="row" alignItems="center" flexWrap="wrap" gap={1} sx={{ p: 2 }}>
        <Typography variant="h6" sx={{ mr: 2 }}>Transfers</Typography>
        {filters.map((key) => (
          <Chip
            key={key}
            label={key === ALL ? `All (${lines.length})` : BUCKET_LABELS[key]}
            color={key === bucket ? 'primary' : 'default'}
            variant={key === bucket ? 'filled' : 'outlined'}
            onClick={() => setBucket(key)}
          />
        ))}
      </Stack>
      <Table size="small" aria-label="Adyen transfers">
        <TableHead>
          <TableRow>
            <TableCell>Time</TableCell>
            <TableCell>Movement</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>PSP Reference</TableCell>
            <TableCell>Merchant Reference</TableCell>
            <TableCell align="right">Amount</TableCell>
            <TableCell align="right">Commission</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {shown.map((line) => (
            <TableRow key={line.id} sx={line.state === 'settled' ? undefined : { opacity: 0.55 }}>
              <TableCell>{line.createdAt ? moment(line.createdAt).format('DD/MM/YYYY HH:mm:ss') : '-'}</TableCell>
              <TableCell>
                {BUCKET_LABELS[line.bucket]}
                {line.splitType && line.splitType !== 'BalanceAccount' && (
                  <Typography variant="caption" color="textSecondary" display="block">{line.splitType}</Typography>
                )}
                {line.bucket === 'other' && (
                  <Typography variant="caption" color="textSecondary" display="block">{line.type}</Typography>
                )}
              </TableCell>
              <TableCell>{line.status}</TableCell>
              <TableCell>{line.pspReference || '-'}</TableCell>
              <TableCell>{line.merchantReference || line.description || '-'}</TableCell>
              <TableCell align="right">{money(line.amount)}</TableCell>
              <TableCell align="right">{line.commission !== undefined ? money(line.commission) : '-'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

StatementLines.propTypes = {
  lines: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      bucket: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default StatementLines;
